export default __webpack_public_path__ + "static/media/portrait.881979fa.svg";